var _circle, _polygon, _circle2, _polygon2, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _rect6, _rect7, _rect8, _path8, _path9, _path10, _polyline, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _polygon3, _path46, _polygon4, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _circle3, _path55, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawOrdinaryDayReV5Hy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 909,
    height: 529.32087,
    viewBox: "0 0 909 529.32087",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 248.18685,
    cy: 402.13952,
    r: 44.68221,
    fill: "#c7a46d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.695,557.63488a44.68569,44.68569,0,0,0,74.45376,47.29035A44.68606,44.68606,0,1,1,360.695,557.63488Z",
    transform: "translate(-145.5 -185.33957)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "248.31 402.139 248.432 402.139 250.642 528.821 245.977 528.821 248.31 402.139",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.78162,
    cy: 273.4083,
    r: 90.08744,
    fill: "#c7a46d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.764,398.57653a90.09446,90.09446,0,0,0,150.1123,95.34591A90.0952,90.0952,0,1,1,236.764,398.57653Z",
    transform: "translate(-145.5 -185.33957)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.029 273.408 158.277 273.408 162.732 528.821 153.327 528.821 158.029 273.408",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 338.809,
    y: 396.62069,
    width: 412.92155,
    height: 122.40757,
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 521.19629,
    y: 421.91825,
    width: 48.14698,
    height: 97.11001,
    fill: "#cacaca"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 362.88249,
    y: 252.17975,
    width: 364.77457,
    height: 112.61497,
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M910.13873,444.45574H471.40082a3.67218,3.67218,0,0,1-2.54478-6.31961l119.90743-115.256v-50.203a3.67636,3.67636,0,0,1,3.67222-3.67222h23.66547a3.67624,3.67624,0,0,1,3.67222,3.67222V293.0736l9.05685-8.70561a81.37342,81.37342,0,0,1,110.80037-1.84248l172.96346,155.527a3.67253,3.67253,0,0,1-2.45533,6.40328Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cacaca"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.17643,280.74152h0a23.25742,23.25742,0,0,1,23.25742,23.25742v31.418a0,0,0,0,1,0,0H435.919a0,0,0,0,1,0,0v-31.418a23.25742,23.25742,0,0,1,23.25742-23.25742Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M545.26975,281.14954h0A23.25742,23.25742,0,0,1,568.52722,304.407v31.418a0,0,0,0,1,0,0H522.01234a0,0,0,0,1,0,0V304.407A23.25742,23.25742,0,0,1,545.26975,281.14954Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M631.36308,281.55757h0A23.25742,23.25742,0,0,1,654.62054,304.815v31.418a0,0,0,0,1,0,0H608.10567a0,0,0,0,1,0,0V304.815A23.25742,23.25742,0,0,1,631.36308,281.55757Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M665.6372,420.69418h0a23.25742,23.25742,0,0,1,23.25742,23.25742v31.418a0,0,0,0,1,0,0H642.37979a0,0,0,0,1,0,0v-31.418A23.25742,23.25742,0,0,1,665.6372,420.69418Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M435.511,420.69418h0a23.25742,23.25742,0,0,1,23.25742,23.25742v31.418a0,0,0,0,1,0,0H412.25355a0,0,0,0,1,0,0v-31.418A23.25742,23.25742,0,0,1,435.511,420.69418Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M957.55673,583.87153l-77.45945-34.27412a3.26367,3.26367,0,0,0-1.32071-.27918H509.61772a3.26265,3.26265,0,0,0-1.22925.24028l-84.31459,34.27412a3.26423,3.26423,0,0,0,1.22925,6.28813H447.1787v112.615h-2.44815v11.4247H936.809v-11.4247h-4.08025v-112.615H956.236A3.26418,3.26418,0,0,0,957.55673,583.87153Zm-31.35638,118.8642H453.70711v-112.615H926.20035Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cacaca"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 428.57456,
    y: 330.92862,
    width: 59.57169,
    height: 9.79261,
    fill: "#cacaca"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 515.89196,
    y: 330.92862,
    width: 59.57169,
    height: 9.79261,
    fill: "#cacaca"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 603.20936,
    y: 330.92862,
    width: 59.57169,
    height: 9.79261,
    fill: "#cacaca"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 635.85138,
    y: 472.10536,
    width: 59.57169,
    height: 9.79261,
    fill: "#cacaca"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 404.90909,
    y: 472.10536,
    width: 59.57169,
    height: 9.79261,
    fill: "#cacaca"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.5,714.66043h-907a1,1,0,0,1,0-2h907a1,1,0,0,1,0,2Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M813.48835,630.319l-.28231-3.51428c-.36586-1.37908-3.81017,2.94754-4.22114,3.0416a10.22236,10.22236,0,0,0-3.30859-.14891c.14749-6.30618-.82252-3.44705-3.63995-.60126-9.07787,4.60139-5.74873,19.13987,4.58718,19.21311C816.04832,648.85767,820.73664,636.04758,813.48835,630.319Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M814.76417,644.58029c3.75891-.05978,8.48791,13.13153-.4199,13.19989-4.60923.03537-12.76915.93432-12.76915.93432s-6.3431-9.51977-3.51413-15.44237Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "660.996 466.212 660.996 473.046 664.191 473.046 666.726 466.087",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M809.69128,658.51048c-.06488-.072-3.455.15415-3.32-.1245l.00006-6.83466c.56506-.91558.11168,6.79833.24916,6.71h2.98358c.14679-.086,2.35234-7.08645,2.66468-6.95145a.12421.12421,0,0,1,.07477.15951C812.22505,651.55438,809.93034,658.55332,809.69128,658.51048Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M817.39641,657.967c.08986,1.1234-5.32252,1.12341-5.23223-.00014C812.07432,656.84365,817.48669,656.84363,817.39641,657.967Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M813.4722,657.21964c-.31255.07622-1.36853-5.1088,1.84239-5.842C812.18967,653.043,813.79994,656.89232,813.4722,657.21964Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M817.91,656.081c-.01756-.02514-.03032-.05162-.04556-.0774l-.40838.015Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M831.48551,652.132c-1.84024-2.73794-5.39558-1.49323-6.7866,1.01105-1.6503,3.02144-8.69959.7741-7.82022,4.83193C821.28115,657.04574,834.30821,660.22415,831.48551,652.132Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M806.08022,647.40956c-2.89088.56438-7.98894-3.01744-8.12521-4.07278a.12442.12442,0,0,1,.21211-.12992,9.16283,9.16283,0,0,0,3.91024,3.15852c2.43589,1.23369,6.88606,1.26205,12.79452-1.84792A15.81562,15.81562,0,0,1,806.08022,647.40956Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M806.6205,641.08685c-.65292.20313-1.21927-1.37243-.62279-.87223a.6235.6235,0,0,0,.62279.62308c.53223.05242.50684-.52871.74731-.74759C807.78339,640.42393,807.07167,641.14983,806.6205,641.08685Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M805.437,657.98815c-.2477.03355-1.99535-6.24176-2.11211-6.33686a.12473.12473,0,0,1,.081-.15635c.32624-.13026,2.002,6.24718,2.15008,6.3309A.12543.12543,0,0,1,805.437,657.98815Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M810.66925,658.83908c.08986,1.1234-5.32252,1.12341-5.23223-.00014C805.34715,657.71569,810.75953,657.71567,810.66925,658.83908Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M806.43363,658.7145c.08986,1.1234-5.32252,1.12342-5.23223-.00014C801.11153,657.59111,806.52391,657.59109,806.43363,658.7145Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M807.6794,638.6576c.032.49434-2.02535.49435-1.99323-.00006C805.65421,638.16326,807.71151,638.16325,807.6794,638.6576Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M799.98154,638.6857a3.0468,3.0468,0,0,1,4.6642,0c3.21343-2.97958-1.53893-7.95828-4.66441-4.88561A3.37993,3.37993,0,0,0,799.98154,638.6857Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M809.1004,638.6857a3.0468,3.0468,0,0,1,4.6642,0c3.21343-2.97957-1.53892-7.95828-4.6644-4.88561A3.37993,3.37993,0,0,0,809.1004,638.6857Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M800.833,635.40952a1.1622,1.1622,0,0,1-.00011,2.32354A1.1622,1.1622,0,0,1,800.833,635.40952Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M809.95149,635.40952a1.1622,1.1622,0,0,1-.0001,2.32354A1.1622,1.1622,0,0,1,809.95149,635.40952Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M811.54123,639.10817a1.01841,1.01841,0,0,1-.00009,2.03607A1.01841,1.01841,0,0,1,811.54123,639.10817Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#ff6584"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M802.34139,639.10817a1.01841,1.01841,0,0,1-.00009,2.03607A1.01841,1.01841,0,0,1,802.34139,639.10817Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#ff6584"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M510.18964,243.56742a1.01829,1.01829,0,0,1-1.01475-.947A35.99078,35.99078,0,0,0,473.378,209.271c-1.08561,0-2.226.05519-3.38984.16409a1.018,1.018,0,0,1-.97858-.50769,42.76517,42.76517,0,0,0-78.20491,9.30122,1.01362,1.01362,0,0,1-1.00145.73467l-.27075-.0082c-.14084-.00472-.28156-.0097-.42352-.0097a30.16127,30.16127,0,0,0-29.39139,23.8138,1.01836,1.01836,0,0,1-.99648.80827H290.49673a1.01836,1.01836,0,1,1,0-2.03671h67.40935a32.21611,32.21611,0,0,1,31.16768-24.62207,44.80149,44.80149,0,0,1,81.375-9.557c1.0017-.07807,1.98438-.11735,2.92927-.11735a38.03415,38.03415,0,0,1,37.82864,35.24346,1.01827,1.01827,0,0,1-.94464,1.08722C510.23775,243.56667,510.21363,243.56742,510.18964,243.56742Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cbcbcb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M498.07315,256.62457H331.06258a1.01836,1.01836,0,0,1,0-2.03672H498.07315a1.01836,1.01836,0,1,1,0,2.03672Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cbcbcb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M371.79686,271.39075H315.78722a1.01836,1.01836,0,1,1,0-2.03672h56.00964a1.01836,1.01836,0,1,1,0,2.03672Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cbcbcb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.18964,319.56742a1.01829,1.01829,0,0,1-1.01475-.947A35.99078,35.99078,0,0,0,1008.378,285.271c-1.08561,0-2.226.05519-3.38984.16409a1.018,1.018,0,0,1-.97858-.50769,42.76517,42.76517,0,0,0-78.20491,9.30122,1.01362,1.01362,0,0,1-1.00145.73467l-.27075-.0082c-.14084-.00472-.28156-.0097-.42352-.0097a30.16127,30.16127,0,0,0-29.39139,23.8138,1.01836,1.01836,0,0,1-.99648.80827H825.49673a1.01836,1.01836,0,1,1,0-2.03671h67.40935a32.21611,32.21611,0,0,1,31.16768-24.62207,44.80149,44.80149,0,0,1,81.375-9.557c1.0017-.07807,1.98438-.11735,2.92927-.11735a38.03415,38.03415,0,0,1,37.82864,35.24346,1.01827,1.01827,0,0,1-.94464,1.08722C1045.23775,319.56667,1045.21363,319.56742,1045.18964,319.56742Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cbcbcb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.07315,332.62457H866.06258a1.01836,1.01836,0,0,1,0-2.03672h167.01057a1.01836,1.01836,0,1,1,0,2.03672Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cbcbcb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M906.79686,347.39075H850.78722a1.01836,1.01836,0,1,1,0-2.03672h56.00964a1.01836,1.01836,0,0,1,0,2.03672Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#cbcbcb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "b1a8541e-143e-4538-83fe-9ad513a1421c-1475",
    "data-name": "Path 438",
    d: "M324.99847,696.69064c12.90671,3.70548,13.05957-14.53448,15.11318-22.74232-7.29521,4.96744-19.59555,12.04951-15.06565,22.5203",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "b8cf628a-e9ed-4a73-b365-3d3d5b22b3b0-1476",
    "data-name": "Path 439",
    d: "M325.71039,710.84215c-1.6954-9.589-1.80238-21.734,7.60668-27.40146.44943-.2839.86351.42884.41564.71159-9.08411,5.49441-8.81431,17.22737-7.22681,26.47038a.41267.41267,0,0,1-.79524.21893Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "a23791c3-92dd-4f50-a474-9928a61c2106-1477",
    "data-name": "Path 442",
    d: "M329.88736,704.0582c5.90622,7.92823,14.13105-2.68754,18.99453-6.57869-6.4875-.34491-16.85045-1.682-18.86675,6.47018",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "b60c076d-9097-4801-ac73-7cc88add5974-1478",
    "data-name": "Path 443",
    d: "M324.07,713.27245c3.33852-6.39122,8.67016-13.61924,16.798-12.70657.52791.04539.396.85924-.131.81391-7.7204-.79891-12.7435,6.14441-15.91368,12.2286C324.56461,714.066,323.80846,713.73543,324.07,713.27245Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "a67956e2-8b98-4e4d-9992-a085a750263d-1479",
    "data-name": "Path 438",
    d: "M980.76531,696.69064c-12.90671,3.70548-13.05957-14.53448-15.11318-22.74232,7.29521,4.96744,19.59555,12.04951,15.06565,22.5203",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "f3f3b4ba-0cf2-43e5-a143-29a7044919d2-1480",
    "data-name": "Path 439",
    d: "M980.05339,710.84215c1.6954-9.589,1.80238-21.734-7.60669-27.40146-.44942-.2839-.8635.42884-.41563.71159,9.08411,5.49441,8.81431,17.22737,7.22681,26.47038a.41267.41267,0,0,0,.79524.21893Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "bcecc833-60d4-4858-ab03-197f92115e3a-1481",
    "data-name": "Path 442",
    d: "M975.87641,704.0582c-5.90621,7.92823-14.131-2.68754-18.99452-6.57869,6.4875-.34491,16.85045-1.682,18.86675,6.47018",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "a6f598c3-c8a7-42f2-b39d-9dc53dda9960-1482",
    "data-name": "Path 443",
    d: "M981.69374,713.27245c-3.33852-6.39122-8.67016-13.61924-16.798-12.70657-.52791.04539-.396.85924.131.81391,7.7204-.79891,12.7435,6.14441,15.91367,12.2286C981.19917,714.066,981.95532,713.73543,981.69374,713.27245Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "fd275a8b-ba12-4d4d-adbf-79ebe2765098-1483",
    "data-name": "Path 438",
    d: "M1035.035,683.95445c-22.499,6.45939-22.76545-25.33651-26.34531-39.64442,12.717,8.65924,34.159,21.00471,26.26244,39.25739",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "fd36d152-0ef2-4ddc-ad5e-c52cba6d2e61-1484",
    "data-name": "Path 439",
    d: "M1033.794,708.62337c2.95542-16.71558,3.14191-37.88678-13.26-47.76623-.78344-.4949-1.50526.74755-.72454,1.24043,15.83543,9.57786,15.36511,30.03078,12.59778,46.14318a.71936.71936,0,0,0,1.38626.38165Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "b2b22ba2-fa03-45e4-b19b-719bd4738787-1485",
    "data-name": "Path 442",
    d: "M1026.51268,696.79758c-10.29572,13.8205-24.63324-4.68491-33.11126-11.468,11.309-.60126,29.37371-2.9321,32.88853,11.27882",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "b34fb090-06bf-4a57-8290-23762b8330c7-1486",
    "data-name": "Path 443",
    d: "M1036.65345,712.85988c-5.81971-11.14118-15.11384-23.74107-29.28221-22.1501-.92025.07912-.69034,1.49782.22832,1.4188,13.4582-1.39266,22.21448,10.71094,27.74072,21.31691C1035.79131,714.24315,1037.10943,713.66694,1036.65345,712.85988Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.898 525.12 83.698 525.12 85.506 510.462 79.898 510.462 79.898 525.12",
    fill: "#ffb6b6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M224.429,709.21869l7.48393-.0003h.0003a4.76961,4.76961,0,0,1,4.76935,4.76927v.155l-12.25335.00046Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "97.877 525.12 101.677 525.12 103.485 510.462 97.876 510.462 97.877 525.12",
    fill: "#ffb6b6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M242.40722,709.21869l7.48392-.0003h.00031a4.76959,4.76959,0,0,1,4.76934,4.76927v.155l-12.25335.00046Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#2f2e41"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M250.46874,643.44855a3.32992,3.32992,0,0,0-.77877-5.04628l-6.18432-29.69171-6.73748,2.65449,8.19755,28.3513a3.348,3.348,0,0,0,5.503,3.7322Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#ffb6b6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M221.32275,637.73075l-2.801,2.84329s-3.00311,11.005,2.74351,24.5773l3.84363,39.35066,6.91542.52073,2.06442-45.78118,9.52536,15.19645-1.66379,30.422,7.64423-.17573,3.45482-33.70984-9.43526-35.1767Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#2f2e41"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M231.11667,641.56117a107.235,107.235,0,0,1-12.6153-.83334l-.16846-.0224,4.17423-18.34574-1.43732-23.60448,13.57284-.465a4.98727,4.98727,0,0,1,5.11609,4.26633l2.77792,18.83233,2.56967,16.70811-.03444.05025C243.22525,640.855,237.05113,641.56117,231.11667,641.56117Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M233.40772,602.19431l2.75775-3.45716s4.83459-3.30614,6.36465,3.77854,4.37287,18.58587,4.37287,18.58587l-9.45346.76555Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M207.27459,643.75852a3.32991,3.32991,0,0,1,.77876-5.04628l6.18433-29.69171,6.73748,2.65449-8.19756,28.3513a3.348,3.348,0,0,1-5.503,3.7322Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#ffb6b6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M224.33561,602.50428l-2.75776-3.45716s-4.83458-3.30614-6.36465,3.77854-4.37287,18.58587-4.37287,18.58587l9.45346.76555Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#c7a46d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M235.95763,594.83814H217.97938a1.39644,1.39644,0,0,1-1.39487-1.39486V585.694a10.384,10.384,0,0,1,20.768,0v7.74925A1.39644,1.39644,0,0,1,235.95763,594.83814Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.45343,
    cy: 401.41861,
    r: 7.61318,
    fill: "#ffb6b6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M239.8091,586.469H228.81584l-.11276-1.57831-.56364,1.57831h-1.69272l-.2234-3.12816-1.11713,3.12816h-3.27534v-.155a8.22342,8.22342,0,0,1,8.21412-8.2142h1.54993a8.22349,8.22349,0,0,1,8.2142,8.2142Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#2f2e41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72587,596.2847a1.42491,1.42491,0,0,1-.24686-.0218l-8.04976-1.42029V581.53873h8.86124l-.21939.25578c-3.05232,3.55981-.75275,9.33209.88965,12.456a1.37421,1.37421,0,0,1-.1092,1.459A1.38928,1.38928,0,0,1,228.72587,596.2847Z",
    transform: "translate(-145.5 -185.33957)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawOrdinaryDayReV5Hy);
export default __webpack_public_path__ + "static/media/undraw_ordinary_day_re_v5hy.46cfc1098c9adce3158d40ba053aa18d.svg";
export { ForwardRef as ReactComponent };